/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCustomerVisits200ResponseItemsInner } from './GetCustomerVisits200ResponseItemsInner';
import {
    GetCustomerVisits200ResponseItemsInnerFromJSON,
    GetCustomerVisits200ResponseItemsInnerFromJSONTyped,
    GetCustomerVisits200ResponseItemsInnerToJSON,
    GetCustomerVisits200ResponseItemsInnerToJSONTyped,
} from './GetCustomerVisits200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetCustomerVisits200Response
 */
export interface GetCustomerVisits200Response {
    /**
     * 
     * @type {Array<GetCustomerVisits200ResponseItemsInner>}
     * @memberof GetCustomerVisits200Response
     */
    items: Array<GetCustomerVisits200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerVisits200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerVisits200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerVisits200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetCustomerVisits200Response interface.
 */
export function instanceOfGetCustomerVisits200Response(value: object): value is GetCustomerVisits200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetCustomerVisits200ResponseFromJSON(json: any): GetCustomerVisits200Response {
    return GetCustomerVisits200ResponseFromJSONTyped(json, false);
}

export function GetCustomerVisits200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerVisits200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetCustomerVisits200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetCustomerVisits200ResponseToJSON(json: any): GetCustomerVisits200Response {
    return GetCustomerVisits200ResponseToJSONTyped(json, false);
}

export function GetCustomerVisits200ResponseToJSONTyped(value?: GetCustomerVisits200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetCustomerVisits200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

